<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>民主生活记录</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="contrl_bar" style="display:flex;justify-content: flex-end;">
						<el-upload
							:data="{token:$store.state.user.userinfo.token}"
							name="file"
							style="margin-right:10px;"
							:action="$uploadFile"
							:show-file-list="false"
							multiple
							:on-success="success1"
							:on-progress="uploadProcess"
							:before-upload="limitFiles">
							<el-button size="small" type="primary">上传材料</el-button>
						</el-upload>
						<el-button type="primary"  size="small"
						@click="$router.go(-1)">返回上级</el-button>
					</div>
					<div class="txthdetail">
						<div class="userinfos">
							<div class="userimg">
								<img src="../../../assets/images/moren.png" 
								v-if="u_picture==''||u_picture==null||u_picture.search('http')==-1">
								<img :src="u_picture" v-else>
							</div>
							<div class="usermess">
								<div class="username">
									<div class="useritem">{{u_name}}</div>
									<div class="useritem">{{cy_zz}}</div>
								</div>
								<div class="level">等级：{{level}}</div>
							</div>
						</div>
					</div>
					<div class="content">
						<el-collapse >
							<el-collapse-item title="党员自评">
								<div class="dyzp">
									<div class="levels">
										<div class="level"></div>
									<div class="level" v-for="item in zpLevels">{{item}}</div>
									</div>
									<div class="users" v-for="(items,keys) in levelList">
										<div class="username">{{keys+1}}.{{items.title}}</div>
										<div class="username" 
											v-for="(item,index) in zpLevels.length">
											<i 
											v-if="items.level == index+1"
											class="el-icon-success" style="color: #13CE66; font-size: 18px;"></i>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<el-collapse-item title="党员互评">
								<div class="dyzp dyzp1">
									<div class="levels">
										<div class="level"></div>
										<div class="level" v-for="item in hpLevels">{{item}}</div>
									</div>
									<div class="users" v-for="(items,keys) in userList">
										<div class="username">{{keys+1}}.{{items.title}}</div>
										<div class="username" 
											v-for="(item,index) in hpLevels.length">
											<span v-if="items.level==1">优秀</span>
											<span v-if="items.level==2">合格</span>
											<span v-if="items.level==3">基本合格</span>
											<span v-if="items.level==4">不合格</span>
										</div>
									</div>
									<div class="pages">
										<el-pagination
										  small
										  :current-page="current"
										  layout="prev, pager, next"
										  :total="totalPage">
										</el-pagination>
									</div>
								</div>
							</el-collapse-item>
							<el-collapse-item title="支部讲评">
								<div class="zbjp">
									<textarea v-model="formData.branch_content" rows="8" cols="" @blur="submit(1)"></textarea>
								</div>
							</el-collapse-item>
							<el-collapse-item title="上级点评">
								<div class="zbjp">
									<textarea v-model="formData.superior_content" rows="8" cols="" @blur="submit()"></textarea>
								</div>
							</el-collapse-item>
							<el-collapse-item title="民主测评">
								<div class="mzcp">
									<div class="mzcp_item">优秀(17人)</div>
									<div class="mzcp_item">合格(10人)</div>
									<div class="mzcp_item">基本合格(8人)</div>
									<div class="mzcp_item">不合格(1人)</div>
								</div>
							</el-collapse-item>
							<el-collapse-item title="文件备份">
								<div class="fileList" style="margin-left:0;width: 100%;">
									<div class="file" 
									:key="index"
									v-for="(item,index) in dwFlies.files">
										<i class="el-icon-document" style="margin-right:10px"></i>
										<span style="margin-right:80px">{{item.title}}</span>
										<i style="cursor: pointer;" class="el-icon-close" @click="deluserFile(item.id)"></i>
									</div>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import detail from './mixins/detail.js'
	export default {
		mixins:[detail]
	}
</script>

<style lang="scss" scoped>
	@import './index.scss';
</style>
